import { configureStore } from "@reduxjs/toolkit";
import filterReducer from "./Slices/filterSlice";
import cakeReducer from "./Slices/cakeSlice";
import cartReducer from "./Slices/cartSlice";

export const store = configureStore({
  reducer: {
    filter: filterReducer,
    cake: cakeReducer,
    cart: cartReducer,
  },
});
